import type { DocumentPlace } from '../types';

export function getPlace(search: string): DocumentPlace | null {
  const queryParams = new URLSearchParams(search);

  if (queryParams.has('privacy_policy')) {
    return 'privacy_policy';
  }

  if (queryParams.has('aml_manual')) {
    return 'aml_manual';
  }

  if (queryParams.has('general_terms')) {
    return 'general_terms';
  }

  if (queryParams.has('responsible_gaming')) {
    return 'responsible_gaming';
  }

  if (queryParams.has('terms_of_service')) {
    return 'terms_of_service';
  }

  if (queryParams.has('about_company')) {
    return 'about_company';
  }

  return null;
}
